import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  CardActions,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Switch,
  FormControlLabel,
  Divider,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Paper,
  Tooltip,
  CircularProgress,
  Backdrop
} from "@mui/material";
import {
  AddCircle as AddCircleIcon,
  Delete as DeleteIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Add as AddIcon
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import SunEditor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { BASE_URL } from "../../variables/api";

const EditForm = (props) => {
  let navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    FormArr: [],
    description: "",
  });

  useEffect(() => {
    setLoading(true);
    axios.post(`${BASE_URL}/surveys/getsurvey.php`, { id })
      .then((res) => {
        if (res.data && res.data.data) {
          setFormData((prevstate) => ({
            ...prevstate,
            name: res.data.data.name,
            FormArr: res.data.data.questions || [],
            description: res.data.data.description,
          }));
        }
      })
      .catch((err) => {
        console.error("Error fetching survey:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const handleClickBack = () => {
    navigate("/");
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((prevstate) => ({ ...prevstate, [name]: value }));
  };

  const handleChangeDesc = (content) => {
    setFormData((prevstate) => ({ ...prevstate, description: content }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    Swal.showLoading();
    axios
      .post(`${BASE_URL}/surveys/addsurvey.php`, { formData: formData, id: id })
      .then((res) => {
        Swal.fire("Survey Updated Successfully", "", "success").then(() => {
          navigate("/");
        });
      })
      .catch(err => {
        console.error(err);
        Swal.fire("Error", "Failed to update survey", "error");
      });
  };

  const makeid = (length) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const handleChangeSelectLineScale = (event, id, name) => {
    const value = event.target.value;
    let FormArrCopy = [...formData.FormArr];
    FormArrCopy.map((question) => {
      if (question.id === id) {
        if (name === "startnumber") {
          question.startnumber = { value: value, label: value };
        }
        if (name === "endnumber") {
          question.endnumber = { value: value, label: value };
        }
        let start = question.startnumber.value;
        let end = question.endnumber.value;
        if (start !== "" && end !== "") {
          question.options = []; // Reset options
          for (let i = Number(start); i <= Number(end); i++) {
            let length = question.options.length + 1;
            question.options.push({
              id: `option-${length}`,
              value: i,
              response: "",
            });
          }
        }
      }
      return question;
    });
    setFormData((prevstate) => ({ ...prevstate, FormArr: FormArrCopy }));
  };

  let options = [
    { value: "paragraph", label: "Short Answer" },
    { value: "checkbox", label: "Multiple Choice (Multiple selection)" },
    { value: "date", label: "Date" },
    { value: "email", label: "Email" },
    { value: "file", label: "File" },
    { value: "radio", label: "Multiple Choice (Single selection)" },
    { value: "linescale", label: "Line Scale" },
    { value: "select", label: "Dropdown" }, // Added select if missing in NewForm but present in EditForm logic
    { value: "text", label: "Short Text" }, // Added text
    { value: "number", label: "Number" }, // Added number
  ];

  const handleChangeSelect = (event, id) => {
    const value = event.target.value;
    let FormArrCopy = [...formData.FormArr];
    FormArrCopy.map((question) => {
      if (question.id === id) {
        // Find the full option object based on value
        const selectedOption = options.find(opt => opt.value === value);
        question.type = selectedOption || { value: value, label: value };
      }
      return question;
    });
    setFormData((prevstate) => ({ ...prevstate, FormArr: FormArrCopy }));
  };

  const handleChangeDynamic = (event, id) => {
    const name = event.target.name;
    const value = event.target.value;
    const checked = event.target.checked;
    let FormArrCopy = [...formData.FormArr];
    FormArrCopy.map((question) => {
      if (question.id === id) {
        if ("required" === name) {
          question.required = checked;
        } else if ("Question" === name) {
          question.Question = value;
        }
      }
      return question;
    });
    setFormData((prevstate) => ({ ...prevstate, FormArr: FormArrCopy }));
  };

  const handleChangeDynamicOptions = (event, id, optionNumber) => {
    const value = event.target.value;
    let FormArrCopy = [...formData.FormArr];
    FormArrCopy.map((question) => {
      if (question.id === id) {
        question.options.map((option) => {
          if (option.id === `option-${optionNumber}`) {
            option.value = value;
          }
          return option;
        });
      }
      return question;
    });
    setFormData((prevstate) => ({ ...prevstate, FormArr: FormArrCopy }));
  };

  const deleteOptionHandeler = (id, optionid) => {
    let FormArrDeleteCopy = [...formData.FormArr];
    FormArrDeleteCopy.map((question) => {
      if (question.id === id) {
        let index = question.options.findIndex(
          (option) => option.id === `option-${optionid}`
        );
        question.options.splice(index, 1);
      }
      return question;
    });
    setFormData((prevstate) => ({ ...prevstate, FormArr: FormArrDeleteCopy }));
  };

  const AddOptionHandeler = (id) => {
    let FormArrCopy = [...formData.FormArr];
    FormArrCopy.map((question) => {
      if (question.id === id) {
        let length = question.options.length + 1;
        question.options.push({ id: `option-${length}`, value: "" });
      }
      return question;
    });
    setFormData((prevstate) => ({ ...prevstate, FormArr: FormArrCopy }));
  };

  const deleteQuestionHandeler = (id) => {
    let FormArrDeleteCopy = [...formData.FormArr];
    let index = FormArrDeleteCopy.findIndex((question) => question.id === id);
    FormArrDeleteCopy.splice(index, 1);
    setFormData((prevstate) => ({ ...prevstate, FormArr: FormArrDeleteCopy }));
  };

  const handleClick = () => {
    setFormData((prevstate) => ({
      ...prevstate,
      FormArr: formData.FormArr.concat({
        id: makeid(10),
        Question: "",
        type: { value: "paragraph", label: "Short Answer" }, // Default type
        description: "",
        required: false,
        startnumber: "",
        endnumber: "",
        response: "",
        options: [{ id: `option-1`, value: "" }],
      }),
    }));
  };

  let numbers = Array.from({ length: 10 }, (_, i) => ({ value: `${i + 1}`, label: `${i + 1}` }));

  return (
    <Box sx={{ p: 3, maxWidth: 1200, margin: "0 auto" }}>
      {/* Loading Overlay */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress color="inherit" />
          <Typography variant="h6">Loading Survey...</Typography>
        </Box>
      </Backdrop>

      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={handleClickBack} sx={{ mr: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" component="h1" fontWeight="bold">
          Edit Survey
        </Typography>
      </Box>

      <form onSubmit={submitHandler}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={9}>
            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
              <TextField
                fullWidth
                label="Form Name"
                variant="outlined"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                sx={{ mb: 3 }}
              />
              <Typography variant="subtitle1" gutterBottom>
                Description
              </Typography>
              {formData.description != "" ? (
                <SunEditor
                  setContents={formData.description}
                  placeholder="Enter Form Description"
                  onChange={handleChangeDesc}
                  setOptions={{
                  buttonList: buttonList.complex,
                  height: 200,
                }}
              />
              ) : (
                <TextField
                  fullWidth
                  label="Form Description"
                  variant="outlined"
                  name="description"
                  value={formData.description}
                  onChange={handleChangeDesc}
                  required
                  multiline
                  rows={4}
                  sx={{ mb: 3 }}
                />
              )}
            </Paper>

            <Typography variant="h5" sx={{ mb: 2, fontWeight: 'medium' }}>
              Questions
            </Typography>

            {formData.FormArr.map((t, index) => (
              <Card key={t.id} elevation={2} sx={{ mb: 3, position: 'relative', overflow: 'visible' }}>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        label={`Question ${index + 1}`}
                        variant="filled"
                        name="Question"
                        value={t.Question}
                        onChange={(event) => handleChangeDynamic(event, t.id)}
                        required
                        multiline
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel>Question Type</InputLabel>
                        <Select
                          value={t.type.value || "paragraph"}
                          onChange={(event) => handleChangeSelect(event, t.id)}
                          label="Question Type"
                        >
                          {options.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Box sx={{ mt: 3, pl: 2 }}>
                    {(t.type.value === "select" || t.type.value === "checkbox" || t.type.value === "radio") && (
                      <Box>
                        {t.options.map((option, optIndex) => (
                          <Box key={option.id} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <TextField
                              size="small"
                              placeholder={`Option ${optIndex + 1}`}
                              value={option.value}
                              onChange={(event) => handleChangeDynamicOptions(event, t.id, optIndex + 1)}
                              sx={{ width: '70%', mr: 1 }}
                            />
                            <IconButton onClick={() => deleteOptionHandeler(t.id, optIndex + 1)} color="error" size="small">
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        ))}
                        <Button
                          startIcon={<AddIcon />}
                          onClick={() => AddOptionHandeler(t.id)}
                          sx={{ mt: 1 }}
                        >
                          Add Option
                        </Button>
                      </Box>
                    )}

                    {t.type.value === "linescale" && (
                      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <FormControl sx={{ minWidth: 120 }}>
                          <InputLabel>Start</InputLabel>
                          <Select
                            value={t.startnumber?.value || ""}
                            label="Start"
                            onChange={(event) => handleChangeSelectLineScale(event, t.id, "startnumber")}
                          >
                            {numbers.map((num) => (
                              <MenuItem key={num.value} value={num.value}>{num.label}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Typography>to</Typography>
                        <FormControl sx={{ minWidth: 120 }}>
                          <InputLabel>End</InputLabel>
                          <Select
                            value={t.endnumber?.value || ""}
                            label="End"
                            onChange={(event) => handleChangeSelectLineScale(event, t.id, "endnumber")}
                          >
                            {numbers.map((num) => (
                              <MenuItem key={num.value} value={num.value}>{num.label}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                </CardContent>
                <Divider />
                <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={t.required}
                        onChange={(event) => handleChangeDynamic(event, t.id)}
                        name="required"
                        color="primary"
                      />
                    }
                    label="Required"
                  />
                  <Tooltip title="Delete Question">
                    <IconButton onClick={() => deleteQuestionHandeler(t.id)} color="error">
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </CardActions>
              </Card>
            ))}

            <Button
              variant="outlined"
              startIcon={<AddCircleIcon />}
              onClick={handleClick}
              fullWidth
              sx={{ height: 60, borderStyle: 'dashed', borderWidth: 2 }}
            >
              Add New Question
            </Button>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card elevation={3} sx={{ position: 'sticky', top: 20 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Actions
                </Typography>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<SaveIcon />}
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  Update Survey
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  fullWidth
                  onClick={handleClickBack}
                >
                  Cancel
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default EditForm;
